export const emotionCategories = {
    FEAR: "fear",
    JOY: "joy",
    ANGER: "anger",
    GRIEF: "grief",
}

export default emotionCategories;
